// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --audio-call-floating-video-width: min(108px, calc(100vw - 28px));
  --audio-call-floating-video-aspect-ratio: 9 / 16;
}

.active-call-widget {
  position: fixed;
  right: 14px;
  bottom: calc(var(--app-safe-area-bottom, 0px) + 92px);
  z-index: 1200;
  width: var(--audio-call-floating-video-width);
  aspect-ratio: 1/1;
  box-sizing: border-box;
  border-radius: 8px;
  overflow: hidden;
  background: #101114;
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.32);
  border: 1px solid rgba(255, 255, 255, 0.18);
  cursor: pointer;
  touch-action: none;
}

.active-call-widget--video:not(.active-call-widget--native-pip) {
  width: var(--audio-call-floating-video-width);
  aspect-ratio: var(--audio-call-floating-video-aspect-ratio);
}

.active-call-widget__audio {
  display: none;
}

.active-call-widget--native-pip {
  inset: 0;
  width: 100vw;
  height: 100vh;
  aspect-ratio: auto;
  border: none;
  border-radius: 0;
  box-shadow: none;
  cursor: default;
  transform: none !important;
}

.active-call-widget__video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000000;
}

.active-call-widget__video--hidden {
  opacity: 0;
  visibility: hidden;
}

.active-call-widget__fallback {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #15181d 0%, #22262d 100%);
}

.active-call-widget__avatar {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.6);
}

.active-call-widget__avatar user-avatar {
  display: block;
  width: 100%;
  height: 100%;
}

.active-call-widget__fallback-icon {
  position: absolute;
  right: 12px;
  top: 10px;
  font-size: 18px;
  color: #31b800;
}

.active-call-widget__meta {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
}

.active-call-widget__name,
.active-call-widget__status {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active-call-widget__name {
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
}

.active-call-widget__status {
  margin-top: 1px;
  font-size: 11px;
  line-height: 14px;
  color: rgba(255, 255, 255, 0.78);
}

.active-call-widget--native-pip .active-call-widget__meta {
  display: none;
}

@media (max-width: 360px) {
  :host {
    --audio-call-floating-video-width: 96px;
  }
  .active-call-widget:not(.active-call-widget--native-pip) {
    right: 10px;
    bottom: calc(var(--app-safe-area-bottom, 0px) + 86px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/call/ui-components/active-audio-call-widget/active-audio-call-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,iEAAA;EACA,gDAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,qDAAA;EACA,aAAA;EACA,6CAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,2CAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,6CAAA;EACA,2DAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AACF;;AAEA;;EAEE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE;IACE,uCAAA;EACF;EAEA;IACE,WAAA;IACA,qDAAA;EAAF;AACF","sourcesContent":[":host {\n  --audio-call-floating-video-width: min(108px, calc(100vw - 28px));\n  --audio-call-floating-video-aspect-ratio: 9 / 16;\n}\n\n.active-call-widget {\n  position: fixed;\n  right: 14px;\n  bottom: calc(var(--app-safe-area-bottom, 0px) + 92px);\n  z-index: 1200;\n  width: var(--audio-call-floating-video-width);\n  aspect-ratio: 1 / 1;\n  box-sizing: border-box;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #101114;\n  color: #ffffff;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.32);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  cursor: pointer;\n  touch-action: none;\n}\n\n.active-call-widget--video:not(.active-call-widget--native-pip) {\n  width: var(--audio-call-floating-video-width);\n  aspect-ratio: var(--audio-call-floating-video-aspect-ratio);\n}\n\n.active-call-widget__audio {\n  display: none;\n}\n\n.active-call-widget--native-pip {\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  aspect-ratio: auto;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  cursor: default;\n  transform: none !important;\n}\n\n.active-call-widget__video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: #000000;\n}\n\n.active-call-widget__video--hidden {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.active-call-widget__fallback {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #15181d 0%, #22262d 100%);\n}\n\n.active-call-widget__avatar {\n  width: 58px;\n  height: 58px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n}\n\n.active-call-widget__avatar user-avatar {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.active-call-widget__fallback-icon {\n  position: absolute;\n  right: 12px;\n  top: 10px;\n  font-size: 18px;\n  color: #31b800;\n}\n\n.active-call-widget__meta {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: none;\n}\n\n.active-call-widget__name,\n.active-call-widget__status {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.active-call-widget__name {\n  font-size: 13px;\n  line-height: 16px;\n  font-weight: 500;\n}\n\n.active-call-widget__status {\n  margin-top: 1px;\n  font-size: 11px;\n  line-height: 14px;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.active-call-widget--native-pip .active-call-widget__meta {\n  display: none;\n}\n\n@media (max-width: 360px) {\n  :host {\n    --audio-call-floating-video-width: 96px;\n  }\n\n  .active-call-widget:not(.active-call-widget--native-pip) {\n    right: 10px;\n    bottom: calc(var(--app-safe-area-bottom, 0px) + 86px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
